import { TrendingUp, TrendingDown, Minus } from "lucide-react";
import { fmt } from "@/lib/constants";

export const YoYDelta = ({ now, prev, testId, light = false }) => {
  if (prev == null || now == null) return <span data-testid={testId} className={`text-[11px] ${light ? "text-slate-400" : "text-slate-400"}`}>thn lalu: {prev == null ? "-" : fmt(prev)}</span>;
  const delta = Math.round((now - prev) * 10) / 10;
  const Icon = delta > 0 ? TrendingUp : delta < 0 ? TrendingDown : Minus;
  const cls = delta > 0 ? (light ? "text-emerald-300" : "text-emerald-700") : delta < 0 ? (light ? "text-rose-300" : "text-rose-700") : (light ? "text-slate-300" : "text-slate-500");
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 text-[11px] font-medium ${cls}`} title={`Tahun lalu: ${fmt(prev)}`}>
      <Icon size={11} />{delta > 0 ? "+" : ""}{fmt(delta)} <span className="opacity-70 font-normal">vs {fmt(prev)}</span>
    </span>
  );
};
